import {FC, ReactElement} from 'react'
import {styled, Tooltip, tooltipClasses, TooltipProps} from '@mui/material'

type Props = {
  label: string
  children: ReactElement
}

const LightTooltip = styled(({className, ...props}: TooltipProps) => (
  <Tooltip {...props} classes={{popper: className}} />
))(({theme}) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.white,
    color: 'rgba(0, 0, 0, 0.87)',
    boxShadow: theme.shadows[1],
    fontSize: 11,
  },
}))

export const TooltipCustom: FC<Props> = ({label, children}) => {
  return (
    <LightTooltip
      title={
        <div
          style={{fontSize: '13px'}}
          dangerouslySetInnerHTML={{
            __html: label,
          }}
        />
      }
    >
      {children}
    </LightTooltip>
  )
}
